import { useParams } from "react-router";
import { DaResetPassword } from "../../components/DaResetPassword/DaResetPassword";

function DaResetPasswordPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaResetPassword /> : null}
    </div>
  );
}

export default DaResetPasswordPage;
